import {baseUrl} from '../config/config'
import VueRouter from "vue-router";
import {constants} from "./constants";

let arr = {
    Login: () => import('./views/Login.vue'),
    NotFound: () => import('./views/404.vue'),
    Home: () => import('./views/Home.vue'),
    baseMenu: () => import('./views/base/baseMenu.vue'),
    baseUser: () => import('./views/base/baseUser.vue'),
    baseRole: () => import('./views/base/baseRole.vue'),
    fwSecurityCode: () => import('./views/fw/fwSecurityCode.vue'),
    fwAgent: () => import('./views/fw/fwAgent.vue'),
    fwMainLabel: () => import('./views/fw/fwMainLabel.vue'),
    securityQuery: () => import('./views/fw/securityQuery.vue'),
    fwSecurityCodeHis: () => import('./views/fw/fwSecurityCodeHis.vue'),
    fwChannel: () => import('./views/fw/fwChannel.vue'),
    fwShop: () => import('./views/fw/fwShop.vue'),
    fwProduct: () => import('./views/fw/fwProduct.vue'),
    fwBrand: () => import('./views/fw/fwBrand.vue'),
};

/* let routes = [
    {
        path: baseUrl + 'login',
        component: arr.Login,
        name: '',
        hidden: true
    },
    {
        path: baseUrl + '404',
        component: arr.NotFound,
        name: '',
        hidden: true
    },
    {
        path: baseUrl,
        component: arr.Home,
        name: null,
        iconCls: 'fa fa-address-card',
        style: 'width: 14px;margin-right: 12px;',
        leaf: true,//只有一个节点
        children: [
            {path: baseUrl + 'fwChannel', component: arr.fwChannel, name: '渠道管理'}
        ]
    },
    {
        path: baseUrl,
        component: arr.Home,
        name: null,
        iconCls: 'fa fa-address-card',
        style: 'width: 14px;margin-right: 12px;',
        leaf: true,//只有一个节点
        children: [
            {path: baseUrl + 'fwShop', component: arr.fwShop, name: '店铺管理'}
        ]
    },
    {
        path: baseUrl,
        component: arr.Home,
        name: null,
        iconCls: 'fa fa-address-card',
        style: 'width: 14px;margin-right: 12px;',
        leaf: true,//只有一个节点
        children: [
            {path: baseUrl + 'fwBrand', component: arr.fwBrand, name: '品牌管理'}
        ]
    },
    {
        path: baseUrl,
        component: arr.Home,
        name: null,
        iconCls: 'fa fa-address-card',
        style: 'width: 14px;margin-right: 12px;',
        leaf: true,//只有一个节点
        children: [
            {path: baseUrl + 'fwProduct', component: arr.fwProduct, name: '产品管理'}
        ]
    },
    {
        path: baseUrl,
        component: arr.Home,
        name: null,
        iconCls: 'fa fa-address-card',
        style: 'width: 14px;margin-right: 12px;',
        leaf: true,//只有一个节点
        children: [
            {path: baseUrl + 'fwSecurityCode', component: arr.fwSecurityCode, name: '防伪码管理'}
        ]
    },
    {
        path: baseUrl,
        component: arr.Home,
        name: null,
        iconCls: 'fa fa-address-card',
        style: 'width: 14px;margin-right: 12px;',
        leaf: true,//只有一个节点
        children: [
            {path: baseUrl + 'fwAgent', component: arr.fwAgent, name: '代理商管理'}
        ]
    },
    {
        path: baseUrl,
        component: arr.Home,
        name: null,
        iconCls: 'fa fa-address-card',
        style: 'width: 14px;margin-right: 12px;',
        leaf: true,//只有一个节点
        children: [
            {path: baseUrl + 'fwMainLabel', component: arr.fwMainLabel, name: '主页标签'}
        ]
    },
    {
        path: baseUrl,
        component: arr.Home,
        name: null,
        iconCls: 'fa fa-address-card',
        style: 'width: 14px;margin-right: 12px;',
        leaf: true,//只有一个节点
        children: [
            {path: baseUrl + 'fwSecurityCodeHis', component: arr.fwSecurityCodeHis, name: '防伪码查询历史'}
        ]
    },
    {
        path: baseUrl + 'securityQuery',
        component: arr.securityQuery,
        name: '',
        hidden: true
    },

]; */
const router = new VueRouter({
    mode: 'hash',
    routes: getLoginMenu()
});

let hasAddRoutes = false;

// 路由跳转前执行方法
router.beforeEach((to, from, next) => {
    //NProgress.start();
    if (to.path == baseUrl + 'securityQuery') {
        next();
    } else if (!constants.getToken() && to.path !== baseUrl + 'login') {
        // 未登录，并且路由不是登录路由的，指向登录路由
        next({path: baseUrl + 'login'});
    } else {
        if (!hasAddRoutes) {
            hasAddRoutes = true;
            addRouter(true);
        }
        if (to.path === "/") {
            next({path: baseUrl + "home"});
            // let path = sessionStorage.getItem("lastUrl");
            // next({path: path ? path : baseUrl + mainPage});
        } else {
            // 记录当前的访问地址
            sessionStorage.setItem("lastUrl", to.path);
            next();
        }
    }
});

export default router;

function getMenuChildren(item) {
    let onlySelf = !item.children || item.children.length === 0;
    let childArr = null;
    if (!onlySelf) {
        childArr = [];
        for (let idx in item.children) {
            childArr.push(getMenuChildren(item.children[idx]));
        }
    }
    return {
        path: baseUrl + item.data.uri,
        component: arr[item.data.uri],
        name: item.name,
        iconCls: item.data.styleCls,
        style: item.data.style,
        leaf: onlySelf,//只有一个节点
        children: childArr
    };
}

function getMenuObj(menu) {
    let onlySelf = !menu.children || menu.children.length === 0;
    let children = [
        {path: baseUrl + menu.data.uri, component: arr[menu.data.uri], name: menu.name}
    ];
    if (!onlySelf) {
        children = [];
        for (let idx in menu.children) {
            children.push(getMenuChildren(menu.children[idx]));
        }
    }
    return {
        path: baseUrl,
        component: arr.Home,
        name: menu.name,
        iconCls: menu.data.styleCls,
        style: menu.data.style,
        leaf: onlySelf,//只有一个节点
        children: children
    }
}

function getLoginMenu() {
    return [
        {
            path: baseUrl + 'login',
            component: arr.Login,
            name: '',
            hidden: true
        },
        {
            path: baseUrl + 'securityQuery',
            component: arr.securityQuery,
            name: '',
            hidden: true
        },
        {
            path: baseUrl + '404',
            component: arr.NotFound,
            name: '',
            hidden: true
        },
        {
            path: baseUrl,
            component: arr.Home,
            name: '',
            iconCls: 'fa fa-address-card',
            style: 'width: 14px;margin-right: 12px;',
            leaf: true,//只有一个节点
            hidden: true,
            children: [
                {path: baseUrl + 'home', component: null, name: null}
            ]
        }
    ];
}


function getAllTo404() {
    return {
        path: baseUrl + '*',
        hidden: true,
        redirect: {path: baseUrl + '404'}
    }
}

function getAdminMenu() {
    return [
        {
            path: baseUrl,
            component: arr.Home,
            name: "系统管理",
            iconCls: 'fa el-icon-setting',
            style: 'width: 14px;margin-right: 12px;',
            leaf: false,//只有一个节点
            children: [
                {path: baseUrl + 'baseMenu', component: arr.baseMenu, name: '菜单管理'},
                {path: baseUrl + 'baseUser', component: arr.baseUser, name: '用户管理'},
                {path: baseUrl + 'baseRole', component: arr.baseRole, name: '角色管理'},
            ]
        },
    ];
}

function getMenuBtn(menuList, btnObj) {
    if (menuList && menuList.length > 0) {
        menuList.forEach((menu, index, arr) => {
            if (menu.treeEx && menu.treeEx.length > 0) {
                let arr = [];
                for (let idx in menu.treeEx) {
                    arr.push(menu.treeEx[idx].code);
                }
                btnObj[menu.data.uri] = arr;
            }
            getMenuBtn(menu.children, btnObj);
        });
    }
}

export function addRouter(flag) {
    let menuInfo = constants.getMenuInfo();

    let btnObj = {};
    getMenuBtn(menuInfo, btnObj);
    constants.setMenuBtnInfo(btnObj);

    let menuArr = [];
    if (menuInfo) {
        for (let idx in menuInfo) {
            menuArr.push(getMenuObj(menuInfo[idx]));
        }
    }
    let userInfo = constants.getLoginUserInfo();
    if (userInfo && userInfo.isAdmin) {
        menuArr = menuArr.concat(getAdminMenu());
    }

    menuArr.push(getAllTo404());
    router.options.routes = getLoginMenu().concat(menuArr);
    router.addRoutes(menuArr);

    // this.$router.push({
    //     path: this.$route.query.redirect ?
    //         decodeURIComponent(this.$route.query.redirect) :  // 跳到原页面
    //         (baseUrl + mainPage) // 正常进入首页
    // });
    hasAddRoutes = flag;

    let uri = window.location.hash.replace("#/", "");
    router.push({
        path: (baseUrl + (uri == 'login' ? 'home' : uri))
    });
    if (!flag) location.reload();
}



// WEBPACK FOOTER //
// ./src/routes.js